import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Input from '../../form/Input'
import Checkbox from '../../form/Checkbox'

@observer
export default class KioskSettingsModal extends Component {
    render() {
        const { distributeStore, survey } = this.props

        return (
            <Modal
                show={distributeStore.kioskSettingsModalVisible}
                onClose={distributeStore.closeKioskSettingsModal}
            >
                <div className="campaign-links-modal">
                    <div>
                        <h2>{i18n.t('distributionOnsite.kioskSettings')}</h2>

                        <h4>{i18n.t('distributionSurveyLinksModal.subtitle')}</h4>
                    </div>

                    <Input
                        disabled={survey.closed}
                        label={i18n.t('settings.kiosk.password')}
                        placeholder={i18n.t('form.input.placeholder')}
                        onBlur={distributeStore.changePassword}
                        defaultValue={survey.metadata.adminConsole.password}
                    />

                    <Input
                        disabled={survey.closed}
                        type="number"
                        min={0}
                        label={i18n.t('settings.kiosk.redirectMid')}
                        onBlur={distributeStore.redirectAfterTime}
                        defaultValue={survey.metadata.adminConsole.kioskSettings.redirectAfterTime}
                    />

                    <Input
                        disabled={survey.closed}
                        type="number"
                        min={0}
                        label={i18n.t('settings.kiosk.redirectComplete')}
                        onBlur={distributeStore.redirectAfterTimeOnCompletion}
                        defaultValue={
                            survey.metadata.adminConsole.kioskSettings.redirectAfterTimeOnCompletion
                        }
                    />

                    <Input
                        disabled={survey.closed}
                        type="number"
                        min={0}
                        label={i18n.t('settings.kiosk.restartMid')}
                        onBlur={distributeStore.showRestartButtonAfterTime}
                        defaultValue={
                            survey.metadata.adminConsole.kioskSettings.showRestartButtonAfterTime
                        }
                    />

                    <Input
                        disabled={survey.closed}
                        type="number"
                        min={0}
                        label={i18n.t('settings.kiosk.restartPopup')}
                        onBlur={distributeStore.showRestartPopupAfterTime}
                        defaultValue={
                            survey.metadata.adminConsole.kioskSettings.showRestartPopupAfterTime
                        }
                    />

                    <div className="kiosk-settings-modal-checkbox-option">
                        <p>{i18n.t('settings.kiosk.disable')}</p>

                        <Checkbox
                            disabled={survey.closed}
                            defaultChecked={
                                survey.metadata.displaySettings.disableMobileDisplayMode
                            }
                            onBlur={distributeStore.toggleMobileDisplayMode}
                        />
                    </div>
                </div>

                <ModalFooter cssClass="campaign-links-modal-buttons">
                    <Button
                        cssClass="campaign-links-modal-button tertiary"
                        onClick={distributeStore.closeKioskSettingsModal}
                    >
                        {i18n.t('distributionSurveyLinksModal.actionCancel')}
                    </Button>

                    <Button
                        cssClass="campaign-links-modal-button primary"
                        onClick={distributeStore.saveKioskSettings}
                    >
                        {i18n.t('distributionSurveyLinksModal.actionSave')}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}
